// TanStack Query key factory — one place per resource so SSE invalidation (foundation spec "Realtime transport")
// and screens agree on keys.
export const qk = {
  me: () => ['me'] as const,
  tenants: () => ['tenants'] as const,
  assets: (tenant: string, params?: Record<string, unknown>) => ['t', tenant, 'assets', params ?? {}] as const,
  asset: (tenant: string, id: string) => ['t', tenant, 'asset', id] as const,
  channels: (tenant: string) => ['t', tenant, 'channels'] as const,
  channel: (tenant: string, id: string) => ['t', tenant, 'channel', id] as const,
  clips: (tenant: string, params?: Record<string, unknown>) => ['t', tenant, 'clips', params ?? {}] as const,
  clip: (tenant: string, id: string) => ['t', tenant, 'clip', id] as const,
  programmes: (tenant: string, channelId: string, params?: Record<string, unknown>) => ['t', tenant, 'programmes', channelId, params ?? {}] as const,
  availability: (tenant: string, channelId: string, start: number, end: number) => ['t', tenant, 'availability', channelId, start, end] as const,
  jobs: (tenant: string, status?: string) => ['t', tenant, 'jobs', status ?? 'all'] as const,
  stats: (tenant: string, route: string, params?: Record<string, unknown>) =>
    ['t', tenant, 'stats', route, params ?? {}] as const,
  statsRealtime: (tenant: string) => ['t', tenant, 'stats', 'realtime'] as const,
  notifications: (tenant: string) => ['t', tenant, 'notifications'] as const,
  webhookDeliveries: (tenant: string) => ['t', tenant, 'webhook-deliveries'] as const,
  prewarmRuns: (tenant: string) => ['t', tenant, 'prewarm'] as const,
};
